import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';

import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { AuthService } from './auth.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(public auth: AuthService) {}
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // this.progress.start();
    const passedToken = request.headers.get('authorization');
    // token of authorizated user
    const authToken = `Bearer ${this.auth.getToken()}`;
    const differentTokens = authToken !== passedToken;
    const reqCloneObj: any = {};
    if (authToken && !passedToken) {
      reqCloneObj.setHeaders = {
        Authorization: authToken,
      };
    } else if (authToken && differentTokens) {
      reqCloneObj.setHeaders = {
        Authorization: passedToken,
      };
    }
    request = request.clone(reqCloneObj);

    return next.handle(request).pipe(
      tap({
        next: () => {},
        error: (err: any) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status === 401) {
              this.auth.destroyToken();
            }
          }
        },
      })
    );
  }
}
